<template>
  <div id="app">
    <router-view></router-view>
    <el-backtop class="backtop" :bottom="230" :visibility-height="1500">
      <div class="backtop1">
        <i class="el-icon-top"></i>
        <div class="backtop2">TOP</div>
      </div>
    </el-backtop>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  background-color: #efefef;
}
* {
  margin: 0;
  padding: 0;
}
.backtop {
  width: 60px;
  height: 40px;
}
.backtop1 {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  text-align: center;
  line-height: 40px;
  color: #1989fa;
}
.backtop1 i {
  width: 60px;
  height: 55px;
  font-size: 40px;
  line-height: 60px;
  color: white;
  background-color: #4e4c4c;
}
.backtop2 {
  padding: 0 0 0 4px;
  background-color: transparent;
  line-height: 20px;
  color: #000;
}
@media (max-width: 768px){
  .backtop {
  width: 20px !important;
  height: 20px !important;
  background-color:transparent !important;
  box-shadow:none !important;
}
.backtop1 {
  background-color:transparent ;
}
.backtop1 i {
  width: 27px;
  height: 27px;
  font-size: 15px;
  line-height:30px;
  margin: 0 0 0 -4px;
}
.backtop2 {
  padding: 0 0 0 0;
  line-height: 0px;
  font-size: 10px;
}
}
</style>
